import { Box, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';

export const SearchNoResults = () => {
  const { submitCount, isSubmitting } = useFormikContext();
  if (submitCount < 1 || isSubmitting) {
    return null;
  }
  return (
    <Box style={{ margin: '32px 0' }}>
      <Typography variant="h5" align="center">
        Nebyly nalezeny žádné výsledky.
        <br /> Prosím, zkuste jiný dotaz.
      </Typography>
    </Box>
  );
};
